// extracted by mini-css-extract-plugin
module.exports = {"pending":"App_pending__3zvIc","errorWrapper":"App_errorWrapper__OCywS","errorText":"App_errorText__3qu5u","errorWrapperShown":"App_errorWrapperShown__1sMRb"};